const IconChat = () => (
    <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8z"/>
      <path d="M9 9h3M9 12h6"/>
    </svg>
  );
  
  const IconUserCheck = () => (
    <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
      <path d="M16.5 7.5l2 2 3-3"/>
    </svg>
  );
  
  const IconScales = () => (
    <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 3v18M3 7h18M6 7l-3 7h6l-3-7Zm12 0-3 7h6l-3-7Z"/>
    </svg>
  );
  
  function StepCard({ step, title, desc, icon }) {
    return (
      <div className="cl-proc-card">
        <div className="cl-proc-icon">
          <span className="cl-proc-icon-inner">{icon}</span>
        </div>
        <div className="cl-proc-meta">{String(step).padStart(2, "0")}</div>
        <h3 className="cl-proc-title">{title}</h3>
        <p className="cl-proc-desc">{desc}</p>
      </div>
    );
  }
  
  export default function ProcessSection() {
    return (
      <section className="cl-process" id="process">
        <div className="cl-proc-head">
          <p className="cl-eyebrow center">How it works</p>
          <h2 className="cl-title center">Subscribe to a Package or Submit a Service Request</h2>
        </div>
  
        <div className="cl-container cl-proc-grid">
          <StepCard
            step={1}
            icon={<IconChat />}
            title="Submit a Service Request"
            desc="Choose from a list of services tailored for your needs."
          />
          <StepCard
            step={2}
            icon={<IconUserCheck />}
            title="Get Matched with a Lawyer"
            desc="We assign a verified lawyer based on your case."
          />
          <StepCard
            step={3}
            icon={<IconScales />}
            title="Start Your Legal Journey"
            desc="Connect, chat, meet, and manage the entire process easily."
          />
        </div>
      </section>
    );
  }
  